/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Loudness_TitleInputs */

const en_audio_description_export_loudness_title = /** @type {(inputs: Audio_Description_Export_Loudness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loudness Normalization`)
};

const fr_audio_description_export_loudness_title = /** @type {(inputs: Audio_Description_Export_Loudness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalisation du niveau sonore`)
};

const de_audio_description_export_loudness_title = /** @type {(inputs: Audio_Description_Export_Loudness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lautstärkenormalisierung`)
};

const it_audio_description_export_loudness_title = /** @type {(inputs: Audio_Description_Export_Loudness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalizzazione del volume`)
};

const ru_audio_description_export_loudness_title = /** @type {(inputs: Audio_Description_Export_Loudness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нормализация громкости`)
};

const es_audio_description_export_loudness_title = /** @type {(inputs: Audio_Description_Export_Loudness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalización de sonoridad`)
};

const zh_cn2_audio_description_export_loudness_title = /** @type {(inputs: Audio_Description_Export_Loudness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`响度标准化`)
};

const ja_audio_description_export_loudness_title = /** @type {(inputs: Audio_Description_Export_Loudness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ラウドネス正規化`)
};

const hi_audio_description_export_loudness_title = /** @type {(inputs: Audio_Description_Export_Loudness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ध्वनि सामान्यीकरण`)
};

const pt_pt2_audio_description_export_loudness_title = /** @type {(inputs: Audio_Description_Export_Loudness_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Normalização de intensidade sonora`)
};

/**
* | output |
* | --- |
* | "Loudness Normalization" |
*
* @param {Audio_Description_Export_Loudness_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_loudness_title = /** @type {((inputs?: Audio_Description_Export_Loudness_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Loudness_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_loudness_title(inputs)
	if (locale === "de") return de_audio_description_export_loudness_title(inputs)
	if (locale === "it") return it_audio_description_export_loudness_title(inputs)
	if (locale === "ru") return ru_audio_description_export_loudness_title(inputs)
	if (locale === "es") return es_audio_description_export_loudness_title(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_loudness_title(inputs)
	if (locale === "ja") return ja_audio_description_export_loudness_title(inputs)
	if (locale === "hi") return hi_audio_description_export_loudness_title(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_loudness_title(inputs)
	return en_audio_description_export_loudness_title(inputs)
});